<template>
  <div
    v-if="isBlocking"
    class="d-flex flex-column align-items-center justify-content-center flex-grow-1"
  >
    <SplashView>
      <div class="d-flex flex-column align-items-center">
        <template v-if="isPending">
          <div class="spinner-border mb-3"/>
          <h4>Checking your access to this page.</h4>
        </template>
        <template v-else>
          <h4>
            We're sorry. You don't have access to this page.
          </h4>
          <router-link :to="{name:'home'}" class="btn btn-lg">Go Back</router-link>
        </template>
      </div>
    </SplashView>
  </div>
  <slot v-else />
</template>

<script>
import SplashView from "@/components/common/SplashView.vue";

export default {
  components: {SplashView},
  props: {
    accessStatus: String,
    transitionDelayMs: {
      type: Number,
      default: 1200
    }
  },
  data() {
    return {
      accessStatusDelayed: this.accessStatus,
      transitionDate: new Date().getTime() + this.transitionDelayMs,
      transitionTimer: null
    };
  },
  watch: {
    accessStatus: {
      immediate: true,
      handler() {
        clearTimeout(this.transitionTimer);
        const delay = this.transitionDate - new Date();
        this.transitionTimer = setTimeout(() => {
          this.accessStatusDelayed = this.accessStatus;
          this.transitionTimer = null;
        }, Math.max(0, delay));
      }
    }
  },
  unmounted() {
    clearTimeout(this.transitionTimer);
  },
  computed: {
    isBlocking() {
      return Boolean(this.accessStatusDelayed && this.accessStatusDelayed !== 'granted');
    },
    isPending() {
      return this.accessStatusDelayed === 'pending';
    }
  }
}
</script>
